var map = {
	"./Alan.png": "0375",
	"./Alena.png": "be4d",
	"./Alexander.png": "0ea0",
	"./Andrey.png": "9aba",
	"./Anna.png": "caf2",
	"./Dmitry.png": "fd5f",
	"./Fedor.png": "99e7",
	"./Misha.png": "5c9d",
	"./Natalia.png": "baea",
	"./NataliaT.png": "81fb",
	"./Platon.png": "5d2f",
	"./Sofia.png": "2cc1",
	"./Ulyana.png": "bf8d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d8f5";